export default {"src":"/_next/static/media/api-deck-icon.785d0d77.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};